import React from "react";
import { storyblokEditable } from "@storyblok/react";
import { IconButtonModel } from "../Models/IconButtonModel";
import { useNavigate } from "react-router-dom";

import "./IconButton.css";
import Utils from "../Utils/Utils";

interface IconButtonProps {
  blok: IconButtonModel;
  onButtonClick?: () => void;
}

const IconButton: React.FC<IconButtonProps> = ({ blok, onButtonClick }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onButtonClick) {
      onButtonClick();
    }
    if (blok.link?.cached_url) {
      if (blok.link?.linktype === "story") {
        navigate(`/${blok.link.cached_url}`);
      } else {
        const url = new URL(blok.link.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };

  return (
    <a
      className="icon-button-container"
      {...storyblokEditable(blok)}
      onClick={handleClick}
    >
      <img
        src={Utils.getCacheUrl(blok.image.filename)}
        alt={blok.image.alt || "icon"}
        onError={(e) => Utils.handleImageError(e, blok.image.filename)}
      />
    </a>
  );
};

export default IconButton;
